import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import { addAdsInsideParagraph, addEditorAds, convertDt24hFormat, dateCheck } from '@shared-submodule/utils'
import InnerHTML from '@shared/components/InnerHTML'
import { allRoutes } from '@shared-submodule/sm-constants/allRoutes'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import MyImage from '@shared/components/myImage'
import noImage from '@assets/images/placeholder/person-placeholder.png'

const ListicleArticle = dynamic(() => import('../listicleArticle'))
const CustomLink = dynamic(() => import('@shared/components/customLink'))
const CommonContent = dynamic(() => import('@shared/components/commonContent'))
const LiveArticle = dynamic(() => import('@shared/components/liveArticle'))

function ArticleContent({ article, liveArticle }) {
  // const router = useRouter()
  // const isMobileWebView = router?.query?.isMobileWebView
  // const isGlanceView = checkIsGlanceView(router?.query)

  // useEffect(async () => {
  //   const ReactDOM = (await import('react-dom'))
  //   if (isGlanceView) {
  //     if (document.getElementById('fixed-ads-1')) { // After 2nd paragraph
  //       ReactDOM.render(<GlanceAd
  //         id="div-gpt-ad-5"
  //         adId="oneturf_mrec_mid"
  //         dimension={[[300, 250], [336, 280], 'fluid']}
  //       />, document.getElementById('fixed-ads-1'))
  //     }
  //   } else {
  //     const { refreshGoogleAds } = (await import('@shared/libs/ads'))
  //     if (document.getElementById('gt-ads-1')) { // Editor ads one
  //       ReactDOM.render(<Ads
  //         id="div-ad-gpt-138639789-1660131756-0"
  //         adIdDesktop="oneturf2022_Desktop_AP_MID3_728x90"
  //         adIdMobile="oneturf2022_Mobile_AP_MID3_300x250"
  //         dimensionDesktop={[728, 90]}
  //         dimensionMobile={[300, 250]}
  //         mobile
  //         className={'text-center mb-4'}
  //       />, document.getElementById('gt-ads-1'))
  //     }
  //     if (document.getElementById('gt-ads-2')) { // Editor ads Two
  //       ReactDOM.render(<Ads
  //         id="div-ad-gpt-138639789-1660131756-1"
  //         adIdDesktop="oneturf2022_Desktop_AP_MID4_728x90"
  //         adIdMobile="oneturf2022_Mobile_AP_MID4_300x250"
  //         dimensionDesktop={[728, 90]}
  //         dimensionMobile={[300, 250]}
  //         mobile
  //         className={'text-center mb-4'}
  //       />, document.getElementById('gt-ads-2'))
  //     }
  //     if (document.getElementById('fixed-ads-2')) { // After 3rd paragraph fixed ads
  //       ReactDOM.render(<Ads
  //         id="div-ad-gpt-138639789-Desktop_AP_MID-1646637168-0"
  //         adIdDesktop="oneturf2022_Desktop_AP_MID_728x90"
  //         adIdMobile="oneturf2022_Mobile_AP_MID_300x250"
  //         dimensionDesktop={[728, 90]}
  //         dimensionMobile={[300, 250]}
  //         mobile
  //         className={'text-center'}
  //       />, document.getElementById('fixed-ads-2'))
  //     }
  //     if (document.getElementById('fixed-ads-5')) { // After 6th paragraph fixed ads
  //       ReactDOM.render(<Ads
  //         id="div-ad-gpt-138639789_Desktop_AP_MID2_728-46637168-0"
  //         adIdDesktop="oneturf2022_Desktop_AP_MID2_728x90"
  //         adIdMobile="oneturf2022_Mobile_AP_MID2_300x250"
  //         dimensionDesktop={[728, 90]}
  //         dimensionMobile={[300, 250]}
  //         mobile
  //         className={'text-center'}
  //       />, document.getElementById('fixed-ads-5'))
  //     }
  //     // if (document.getElementById('video-ads')) { // Video ads after 1st paragraph
  //     //   ReactDOM.render(<Ads
  //     //     id="div-ad-desk-138639789-1660131489-0"
  //     //     adIdDesktop="oneturf2022_Inread_1x1"
  //     //     dimensionDesktop={[1, 1]}
  //     //     className={'text-center'}
  //     //   />, document.getElementById('video-ads'))
  //     // }
  //     refreshGoogleAds()
  //   }
  // }, [article?._id])

  function getArticleContent() {
    if (article?.bIsListicleArticle) {
      return <ListicleArticle article={article} outerStyle={styles} />
    } else if (article?.iEventId) {
      return (
        <>
          {liveArticle?.oLiveArticleContent?.sFirstContent ? (
            <CommonContent>
              <InnerHTML className={`${styles.content} text-break`} html={liveArticle?.oLiveArticleContent?.sFirstContent} />
            </CommonContent>
          ) : null}
          <div className="my-3">
            <LiveArticle
              liveArticleList={liveArticle?.aLiveArticleList}
              liveArticleEvent={liveArticle?.oLiveArticleEvent}
              liveEventId={article?.iEventId}
            />
          </div>
          {liveArticle?.oLiveArticleContent?.sLastContent ? (
            <CommonContent>
              <InnerHTML className={`${styles.content} text-break`} html={liveArticle?.oLiveArticleContent?.sLastContent} />
            </CommonContent>
          ) : null}
        </>
      )
    } else {
      return (
        <CommonContent>
          <InnerHTML
            className={`${styles.content} text-break`}
            html={addEditorAds(addAdsInsideParagraph(article?.sContent, [0, 1, 2, 5]))}
          />
        </CommonContent>
      )
    }
  }

  const Tag = p => (
    <div key={p?.index}>
      <CustomLink href={'/' + p?.item?.oSeo?.sSlug} prefetch={false}>
        <a target="_blank" className={p?.item?.eStatus === 'i' ? 'disabled' : ''}>
          <span className="badge bg-primary">{p?.item?.sName}</span>
        </a>
      </CustomLink>
    </div>
  )
  return (
    <>
      {getArticleContent()}
      <div className={`${styles.tagList} d-flex flex-lg-wrap pb-2 pb-lg-0`}>
        {article?.aSeries?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
        {article?.aTeam?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
        {article?.aPlayer?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
        {article?.aTags?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
        {/* <Ads
          id="div-ad-gpt-138639789-1646637259-0"
          adIdDesktop="oneturf2022_Desktop_AP_BTF_728x90"
          adIdMobile="oneturf2022_Mobile_AP_BTF_300x250"
          dimensionDesktop={[728, 90]}
          dimensionMobile={[300, 250]}
        /> */}
      </div>
      <div className="d-flex flex-wrap align-items-center mt-4">
        <div className={styles.authorImage}>
          <MyImage
            src={noImage}
            alt={`Author ${article?.oDisplayAuthor?.sDisplayName}`}
            placeholder="blur"
            blurDataURL={BLUR_DATA_URL_BASE64}
          />
        </div>
        <div>
          <span className={styles.author}>
            {article?.oDisplayAuthor?.oSeo?.sSlug ? (
              <CustomLink href={allRoutes.authorDetail(article?.oDisplayAuthor?.oSeo?.sSlug)} prefetch={false}>
                <a>{article?.oDisplayAuthor?.sDisplayName}</a>
              </CustomLink>
            ) : (
              article?.oDisplayAuthor?.sDisplayName
            )}
            {article?.oDisplayAuthor?.bIsVerified && <span className={`${styles.verified} d-inline-block rounded-circle ms-1`}></span>}
          </span>
          <p className={`${styles.dates} w-100 xsmall-text font-semi m-0`}>
            {(article?.dPublishDisplayDate || article?.dPublishDate) && (
              <>
                <time className="op-published" dateTime={dateCheck(article?.dPublishDisplayDate || article?.dPublishDate)?.toISOString()}>
                  {convertDt24hFormat(dateCheck(article?.dPublishDisplayDate || article?.dPublishDate))}
                </time>
              </>
            )}
          </p>
        </div>
      </div>
    </>
  )
}
ArticleContent.propTypes = {
  article: PropTypes.object,
  liveArticle: PropTypes.object
}

export default ArticleContent
